import { fetchInstance } from '@/utils/fetchInstance.ts';

export const sendMessageToBluemap = async (content: string) => {
  await fetchInstance.post('bluemap/send-message', { content });
};
